/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {useContext, useState} from "react";
import {FONTS} from "@res/fonts";
import {DB_Patient} from "@app/app-shared/patient";
import {DialogCard, showDialog} from "../../widget/DialogCard";
import {PatientsContext} from "./PatientsContext";
import {DialogModule} from "@intuitionrobotics/thunderstorm/app-frontend/modules/dialog/DialogModule";

type Props = {
    patient: DB_Patient
}

export const showDeleteUserDialog = (patient: DB_Patient) => showDialog(
    <DeleteUserDialog patient={patient}/>
);

export const DeleteUserDialog = (props: Props) => {
    const [loading, setLoading] = useState(false)
    const {delete: deletePatient} = useContext(PatientsContext);
    const displayMessage = `You are about to delete customer ${props.patient.name}. Are you sure you want to proceed?`;
    return <DialogCard
        style={{width: 500}}
        showX={true}
        title={"Delete Customer"}
        content={FONTS.reg_16_secondary_dark(displayMessage)}
        saveLabel={"Delete"}
        cancelLabel={"Cancel"}
        onSave={() => {
            setLoading(true);
            deletePatient(props.patient._id)
                .then(() => DialogModule.close())
                .catch(console.error)
                .finally(() => setLoading(false));
            return true;
        }}
        loading={loading}
    />;


}
